var render, staticRenderFns
import script from "./menu2.vue?vue&type=script&lang=tsx&"
export * from "./menu2.vue?vue&type=script&lang=tsx&"
import style0 from "./menu2.vue?vue&type=style&index=0&id=7e7aab89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7aab89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7aab89')) {
      api.createRecord('7e7aab89', component.options)
    } else {
      api.reload('7e7aab89', component.options)
    }
    
  }
}
component.options.__file = "src/views/menu2.vue"
export default component.exports